function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10 30v-5c0-3.552 2.448-6 6-6s6 2.448 6 6v5h6V13.568l-12-11.2-12 11.2V30h6zm2 2H2V15.435l-.318.296A1 1 0 0 1 .318 14.27L14.977.587a1.5 1.5 0 0 1 2.046 0l14.66 13.682a1 1 0 1 1-1.365 1.462L30 15.435V32H20v-7c0-2.448-1.552-4-4-4s-4 1.552-4 4v7z"
});

var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "4ee97010203b983e3a2a351a58c57d2e.svg";
export { SvgHome as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/home.svg
// module id = null
// module chunks = 